import { Box } from '@mui/material'
import React, { useMemo } from 'react'
import "./style.css";
import CustomTypography from 'components/Fileds/CustomTypography';
import CustomButton from 'components/Fileds/CustomButton';
import AddIcon from "@mui/icons-material/Add"
import noOrderImg from "assests/order-food.svg"
import { useSelector } from 'react-redux';
import { getOrderTypePermissions, isPermissionAllowed } from 'utils/function';

const NoOrderPanelContainer = ({
  isMobile,
  isDesktop,
  openDialog,
  closeDialog
}) => {
  const posData = useSelector((state) => state?.posData);
  const permissions = useMemo(() => getOrderTypePermissions(posData), [posData]);
  const isTakeAwayAllowed = isPermissionAllowed(permissions, 'permission_take_away');
  const isDineInAllowed = isPermissionAllowed(permissions, 'permission_pos_walk_in_order');
  const isTableBookingAllowed = isPermissionAllowed(permissions, 'permission_table_booking');
  const isPhoneOrderAllowed = isPermissionAllowed(permissions, 'permission_phone_order');

  return (
    <Box className='order-panel-container'
      sx={{
        flexDirection: isDesktop ? "column" : "column",
        flexWrap: isDesktop ? "nowrap" : "wrap",
        justifyContent: isDesktop ? "flex-start" : "center",
      }}
    >
      {/* ——— ICON + TEXT PANEL ——— */}
      <Box className='no-order-container' sx={{ width: isDesktop ? "auto" : "100%", order: isDesktop ? 0 : 1, }}>
        <img
          src={noOrderImg}
          alt="No orders"
          style={{
            width: isMobile ? 120 : 171,
            height: isMobile ? 120 : 171,
            maxWidth: "100%",
          }}
        />

        <CustomTypography
          variant={"body1"}
          label={"You've no order in process"}
          sx={{
            align: 'center', mt: 4, mb: 0, fontWeight: 500,
            color: 'lightgrey.main'
          }}
        />
        <CustomTypography
          variant={"body1"}
          label={"from Counter Desk."}
          sx={{ align: 'center', mt: 0, mb: 0, fontWeight: 500, color: 'lightgrey.main' }}
        />
      </Box>

      {/* ——— BUTTONS PANEL ——— */}
      <Box
        className='booking-btn-container'
        sx={{
          width: isDesktop ? "auto" : "100%",
          order: isDesktop ? 1 : 0,
          mt: isDesktop ? 0 : 0,
          ml: isDesktop ? "10px" : 0,
        }}
      >
        {isTakeAwayAllowed && (
          <CustomButton
            variant="contained"
            startIcon={<AddIcon />}
            fullWidth
            size={isMobile ? "medium" : "large"}
            sx={{
              borderRadius: "10px",
              width: "250px",
              textTransform: "none",
            }}
            // onClick={() => window.dispatchEvent(new CustomEvent("openTakeAwayDialog"))}
            onClick={() => openDialog('takeAway')}
          >
            Take Away Order
          </CustomButton>
        )}

        {isDineInAllowed && (
          <CustomButton
            variant="contained"
            startIcon={<AddIcon />}
            fullWidth
            size={isMobile ? "medium" : "large"}
            sx={{
              borderRadius: "10px",
              width: "250px",
              textTransform: "none",
            }}
            // onClick={() => window.dispatchEvent(new CustomEvent("openDineInDialog"))}
            onClick={() => openDialog('dineIn')}
          >
            Dine-In Order
          </CustomButton>
        )}

        {isTableBookingAllowed && (
          <CustomButton
            variant="contained"
            startIcon={<AddIcon />}
            fullWidth
            size={isMobile ? "medium" : "large"}
            sx={{
              borderRadius: "10px",
              width: "250px",
              textTransform: "none",
            }}
            // onClick={() => window.dispatchEvent(new CustomEvent("openTableBookingDialog"))}
            onClick={() => openDialog('tableBooking')}
          >
            Table Booking
          </CustomButton>
        )}

        {isPhoneOrderAllowed && (
          <CustomButton
            variant="contained"
            startIcon={<AddIcon />}
            fullWidth
            size={isMobile ? "medium" : "large"}
            sx={{
              borderRadius: "10px",
              width: "250px",
              textTransform: "none",
            }}
            // onClick={() => window.dispatchEvent(new CustomEvent("openTableBookingDialog"))}
            onClick={() => openDialog('phoneOrder')}
          >
            Phone Order
          </CustomButton>
        )}
      </Box>
    </Box>
  )
}

export default NoOrderPanelContainer
